// src/theme/tabs.js
// One look for every tab and filter pill in the portal (3.18.6), so pages
// don't each carry their own copy:
//   TAB / TAB_ON        the sections inside a main tab (Logs: Failed
//                       Outgoing / Failed Incoming; Users; Usage; Control
//                       Panel's groups) — components/SectionTabs
//   PILL / PILL_ON      the smaller row under them (Activity log: Everything /
//                       Changes; People's lists; Reminders' lists; Control
//                       Panel's pages in a group)
//   TH_SELECT / TH_OPTION  a picker in a dark table header (the Client
//                       column on People, Activity log, Reminders)
//   NAV / NAV_ON         the main menu buttons (Dashboard, Compose Fax…; 3.20.1)
//   PAGE_TITLE          each main tab's heading (📤 Outgoing Faxes, 🧾 Logs…; 3.19.8)
//   SECTION_TITLE / SECTION_SUB  the title and short explanation between a
//                       row of tabs and the smaller row under it (Users →
//                       Activity log; Control Panel's groups, 3.18.7)
// Colours follow the portal's teal (var(--c-00695c)).

export const TAB = {
  padding: '8px 16px', borderRadius: 20, border: '1.5px solid var(--c-cfd8dc)', background: 'var(--c-ffffff)',
  color: 'var(--t-546e7a)', fontSize: 14, fontWeight: 600, textDecoration: 'none', fontFamily: 'inherit', cursor: 'pointer',
};
export const TAB_ON = { background: 'var(--c-00695c)', border: '1.5px solid var(--c-00695c)', color: 'var(--t-ffffff)' };
export const TAB_ROW = { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 };

export const PILL = {
  padding: '6px 14px', borderRadius: 18, border: '1.5px solid var(--c-cfd8dc)', background: 'var(--c-ffffff)',
  color: 'var(--t-546e7a)', fontSize: 13, fontWeight: 600, textDecoration: 'none', fontFamily: 'inherit', cursor: 'pointer',
};
export const PILL_ON = TAB_ON;
export const PILL_ROW = { display: 'flex', gap: 6, flexWrap: 'wrap' };

export const TH_SELECT = {
  background: 'rgb(var(--c-ffffff-rgb) / 0.14)', color: 'var(--t-ffffff)', border: '1px solid rgb(var(--c-ffffff-rgb) / 0.45)', borderRadius: 6,
  padding: '4px 6px', fontSize: 12, fontWeight: 700, fontFamily: 'inherit', textTransform: 'uppercase',
  letterSpacing: '0.5px', cursor: 'pointer', maxWidth: 190,
};
export const TH_OPTION = { color: 'var(--t-333333)', background: 'var(--c-ffffff)', textTransform: 'none' };

export const SECTION_TITLE = { margin: '0 0 4px', color: 'var(--t-00695c)', fontSize: 18, fontWeight: 700 };
export const SECTION_SUB = { margin: 0, color: 'var(--t-607d8b)', fontSize: 13, lineHeight: 1.5, maxWidth: 980 };

export const PAGE_TITLE = { margin: '0 0 14px', color: 'var(--t-00695c)', fontSize: 22, fontWeight: 700 };

export const NAV = {
  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', background: 'var(--c-ffffff)', color: 'var(--t-00695c)',
  border: '1.5px solid var(--c-b2dfdb)', borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: 'none',
  whiteSpace: 'nowrap', fontFamily: 'inherit', cursor: 'pointer',
};
export const NAV_ON = { background: 'var(--c-00897b)', border: '1.5px solid var(--c-00897b)', color: 'var(--t-ffffff)' };
// The main menu as one joined, centred bar (3.22.0): NAV_BAR holds the
// buttons (NAV_SEG); the open one is NAV_SEG_ON. Only colours change on the
// open one, so no border longhand is ever dropped (see 3.20.2).
export const NAV_BAR = {
  display: 'inline-flex', flexWrap: 'wrap', justifyContent: 'center', maxWidth: '100%',
  background: 'var(--c-ffffff)', border: '1.5px solid var(--c-b2dfdb)', borderRadius: 10, overflow: 'hidden',
};
export const NAV_SEG = {
  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 16px', background: 'var(--c-ffffff)', color: 'var(--t-00695c)',
  fontSize: 14, fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap', fontFamily: 'inherit', cursor: 'pointer',
  boxShadow: 'inset -1px 0 0 var(--c-e0f2f1), inset 0 -1px 0 var(--c-e0f2f1)',
};
export const NAV_SEG_ON = { background: 'var(--c-00897b)', color: 'var(--t-ffffff)' };
